import Vue from 'vue'
import router from '@/router'
import Icon from 'vue-awesome/components/Icon'
import 'bootstrap/dist/css/bootstrap.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue-awesome/icons'
import * as uiv from 'uiv'
import app from '@/app'
import config from '@/app/config'
import { WDCWrapper } from './app/wdc/wdc_wrapper'
import * as Sentry from '@sentry/browser'

if (config.SENTRY_ENABLED) {
  Sentry.init({
    Vue,
    dsn: config.SENTRY_DSN,
    release: config.APP_VERSION,
  })
}

WDCWrapper.init()
Vue.config.productionTip = false
Vue.use(uiv)

Vue.filter('numberWithCommas', number => {
  return number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
})

Vue.component('icon', Icon)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<app/>',
  components: { app }
})
